module.exports = __webpack_public_path__ + "img/f31.b34cc791.jpg";